module.exports = __webpack_public_path__ + "img/Case_8.d56bc97a.jpg";